import { Stack, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Importer } from '@feathr/blackbox';
import { FailureReasonLine } from '@feathr/extender/components/ImportRunLines';

import PartnerImportCountsLine from './PartnerImportCountsLine';

import * as styles from './EventImportCard.css';

interface IEventImportRunDetailsProps {
  importer: Importer;
}

/** What a partner import's run did: why it failed, or what it added, updated, and skipped. */
function EventImportRunDetails({ importer }: Readonly<IEventImportRunDetailsProps>): JSX.Element {
  const theme = useMantineTheme();

  return (
    <Stack align={'flex-start'} className={styles.runDetails} gap={theme.spacing['1']}>
      <FailureReasonLine importer={importer} showIcon={false} />
      <PartnerImportCountsLine importer={importer} />
    </Stack>
  );
}

export default observer(EventImportRunDetails);
